import { render } from "./feels-like.svg.vue?vue&type=template&id=dbaa9af0"
import script from "./feels-like.svg.vue?vue&type=script&lang=js"
export * from "./feels-like.svg.vue?vue&type=script&lang=js"
script.render = render

export default script